<div class="field-row" [class.all-fields-row]="isAllFields">
  <div class="field-name-cell">
    <span class="field-name"
          [class.all-fields-label]="isAllFields"
          [style.color]="textColorValue"
          [style.background-color]="backgroundColorValue"
          [style.font-weight]="getStyleProperties(currentStyle).fontWeight"
          [style.font-style]="getStyleProperties(currentStyle).fontStyle"
          [style.text-decoration]="getStyleProperties(currentStyle).textDecoration">
      {{ getDisplayLabel() }}
    </span>
  </div>
  <div class="field-toolbar">
    <!-- Color Picker -->
    <div class="toolbar-group color-group">
      <a nz-dropdown
         [nzDropdownMenu]="colorMenu"
         nzTrigger="click"
         nz-tooltip
         nzTooltipTitle="Text Color"
         nzPlacement="bottomLeft"
         (click)="onTextColorPickerClick()"
         class="toolbar-button color-button"
         [class.active]="isTextColorActive">
        <span class="color-indicator-button"
              *ngIf="isTextColorActive && currentTextColor"
              [style.background-color]="getTextColorIndicator(currentTextColor)"></span>
        <i class="fa-solid fa-font"></i>
        <i class="fa-solid fa-chevron-down dropdown-icon"></i>
      </a>
      <a nz-dropdown
         [nzDropdownMenu]="backgroundColorMenu"
         nzTrigger="click"
         nz-tooltip
         nzTooltipTitle="Background Color"
         nzPlacement="bottomLeft"
         (click)="onBackgroundColorPickerClick()"
         class="toolbar-button color-button"
         [class.active]="isBackgroundColorActive">
        <span class="color-indicator-button"
              *ngIf="isBackgroundColorActive && (currentBackgroundColor || backgroundColorValue)"
              [style.background-color]="getBackgroundColorIndicator()"></span>
        <i class="fa-solid fa-fill-drip"></i>
        <i class="fa-solid fa-chevron-down dropdown-icon"></i>
      </a>
    </div>

    <!-- Style Buttons -->
    <div class="toolbar-group style-group">
      <!-- Text Color Picker with Icon -->
      <div class="color-picker-wrapper">
        <rappider-color-picker
          [(ngModel)]="textColorPickerValue"
          [triggerIcon]="getTextColorPickerIconConfig()"
          [displayMode]="'icon-only'"
          [okButtonVisible]="true"
          [cancelButtonVisible]="true"
          [saveClickOutside]="true"
          (valueChange)="onTextColorPickerValueChange($event)"
          nz-tooltip
          nzTooltipTitle="Text Color">
        </rappider-color-picker>
      </div>
      <!-- Background Color Picker with Icon -->
      <div class="color-picker-wrapper">
        <rappider-color-picker
          [(ngModel)]="backgroundColorPickerValue"
          [triggerIcon]="getBackgroundColorPickerIconConfig()"
          [displayMode]="'icon-only'"
          [okButtonVisible]="true"
          [cancelButtonVisible]="true"
          [saveClickOutside]="true"
          (valueChange)="onBackgroundColorPickerValueChange($event)"
          nz-tooltip
          nzTooltipTitle="Background Color">
        </rappider-color-picker>
      </div>
      <button type="button"
              *ngFor="let styleBtn of styleButtons"
              class="toolbar-button style-button"
              [class.active]="isStyleActive(styleBtn.type)"
              (click)="onStyleButtonClick(styleBtn.type)"
              nz-tooltip
              [nzTooltipTitle]="styleBtn.tooltip">
        <i [class]="'fa-solid ' + styleBtn.icon"></i>
      </button>
    </div>
  </div>
</div>

<!-- Color Dropdown Menu -->
<nz-dropdown-menu #colorMenu="nzDropdownMenu">
  <ul nz-menu class="color-menu">
    <li nz-menu-item
        *ngFor="let colorOption of textColorOptions"
        [class.selected]="isTextColorOptionSelected(colorOption.value)"
        (click)="onTextColorSelected(colorOption.value)">
      <span class="color-option">
        <span class="color-indicator" [style.background-color]="getTextColorIndicator(colorOption.value)"></span>
        <span>{{ colorOption.key }}</span>
      </span>
    </li>
  </ul>
</nz-dropdown-menu>

<!-- Background Color Dropdown Menu -->
<nz-dropdown-menu #backgroundColorMenu="nzDropdownMenu">
  <ul nz-menu class="color-menu">
    <li nz-menu-item
        *ngFor="let colorOption of textColorOptions"
        [class.selected]="isBackgroundColorOptionSelected(colorOption.value)"
        (click)="onBackgroundColorSelected(colorOption.value)">
      <span class="color-option">
        <span class="color-indicator" [style.background-color]="getTextColorIndicator(colorOption.value)"></span>
        <span>{{ colorOption.key }}</span>
      </span>
    </li>
  </ul>
</nz-dropdown-menu>

